export const EVENT_CREDITS_UPDATE = 'credits_update';
